import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useLanguageContext } from "../../Context/LanguageContext";

const RolesPermissionDialog = ({ open, onClose }) => {
  const { localization } = useLanguageContext();

  const RoleBlock = ({ title, permissions, accessList = [] }) => (
    <>
      <Typography
        variant="header2"
        fontWeight="bold"
        sx={{ mb: 2 }}
        gutterBottom
      >
        {title}
      </Typography>

      {/* ---------Permissions ---------*/}

      <Box sx={{ ml: 5, mb: 1 }}>
        <Typography
          variant="header2"
          fontWeight="bold"
          sx={{ minWidth: "130px", mb: 0.5 }}
        >
          {localization.permissions}{" "}
        </Typography>
        <Typography variant="header2" sx={{ textAlign: "justify", mb: 0.5 }}>
          {permissions}
        </Typography>
      </Box>

      {/* ----------Access to----------- */}
      {accessList.length > 0 && (
        <>
          <Typography
            variant="header2"
            fontWeight="bold"
            sx={{ ml: 5, mt: 1, mb: 0.5 }}
          >
            {localization.accessTo}
          </Typography>
          <List dense sx={{ pl: 8, mt: -1.5 }}>
            {accessList.map((item, index) => (
              <ListItem
                key={index}
                sx={{ display: "list-item", pl: 1, py: 0.3, mt: -0.5 }}
              >
                <ListItemText primary={`◦ ${item}`} />
              </ListItem>
            ))}
          </List>
        </>
      )}
    </>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography variant="h6">
          {localization.rolesAndTheirPermissions}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <RoleBlock
          title={localization.organisationAdmin}
          permissions={localization.organisationPermission}
          accessList={[
            localization.accessToOrganisation1,
            localization.accessToOrganisation2,
          ]}
        />

        <RoleBlock
          title={localization.plantAdmin}
          permissions={localization.plantAdminPermissions}
          accessList={[
            localization.accessToPlant1,
            localization.accessToPlant2,
          ]}
        />

        <RoleBlock
          title={localization.admin}
          permissions={localization.adminPermission}
          accessList={[
            localization.accessToAdmin1,
            localization.accessToAdmin2,
          ]}
        />

        <RoleBlock
          title={localization.prueferLabel}
          permissions={localization.inspectorPermissions}
          accessList={[
            localization.accessToAdmin1,
            localization.accessToInspector2,
          ]}
        />

        <RoleBlock
          title={localization.reader}
          permissions={localization.readerPermissions}
          accessList={[
            localization.accessToReader1,
            localization.accessToInspector2,
          ]}
        />

        <RoleBlock
          title={localization.manageTicket}
          permissions={localization.manageTicketPermissions}
          accessList={[
            localization.accessToManageTicket1,
            localization.accessToManageTicket2,
          ]}
        />
        <Divider className="mb-2" />
        {/* Summary */}
        <Typography variant="header2" fontWeight="bold" gutterBottom>
          {localization.keyPermissionSummary}
        </Typography>
        <List dense>
          <ul>
            <li className="mb-2">
              <b>{localization.organizationAdmin}: </b>
              <span>{localization.keyPermissionSummary1}</span>
            </li>
            <li className="mb-2">
              <b>{localization.plantAdmin} </b>
              <span>{localization.keyPermissionSummary2}</span>
            </li>
            <li className="mb-2">
              <b>{localization.admin}: </b>
              <span>{localization.keyPermissionSummary3}</span>
            </li>
            <li className="mb-2">
              <b>{localization.prueferLabel}: </b>
              <span>{localization.keyPermissionSummary4}</span>
            </li>
            <li className="mb-2">
              <b>{localization.reader}: </b>
              <span>{localization.keyPermissionSummary5}</span>
            </li>
            <li className="mb-2">
              <b>{localization.manageTicket}: </b>
              <span>{localization.keyPermissionSummary6}</span>
            </li>
          </ul>
        </List>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          {localization.close}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RolesPermissionDialog;
